/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApiUserUserType } from './ApiUserUserType';
import {
    ApiUserUserTypeFromJSON,
    ApiUserUserTypeFromJSONTyped,
    ApiUserUserTypeToJSON,
} from './ApiUserUserType';

/**
 * 
 * @export
 * @interface ApiUser
 */
export interface ApiUser {
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiUser
     */
    photo_url?: string;
    /**
     * 
     * @type {ApiUserUserType}
     * @memberof ApiUser
     */
    user_type?: ApiUserUserType;
}

/**
 * Check if a given object implements the ApiUser interface.
 */
export function instanceOfApiUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApiUserFromJSON(json: any): ApiUser {
    return ApiUserFromJSONTyped(json, false);
}

export function ApiUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
        'user_type': !exists(json, 'user_type') ? undefined : ApiUserUserTypeFromJSON(json['user_type']),
    };
}

export function ApiUserToJSON(value?: ApiUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'photo_url': value.photo_url,
        'user_type': ApiUserUserTypeToJSON(value.user_type),
    };
}

